import { Box, BoxProps, Text } from '@qga/roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';
import { useBookingList } from '../BookingListProvider';

type StylingProps = BoxProps;

const BookingListResultSummary = (props: StylingProps) => {
  const { loading, bookingCountLabel } = useBookingList();

  return (
    <Box {...props}>
      {loading && <PulsingLoadingBlock mt={0} mb={0} height="24px" width="140px" />}
      {!loading && (
        <Text fontSize="18px" color="emperor">
          {bookingCountLabel}
        </Text>
      )}
    </Box>
  );
};

export default BookingListResultSummary;
